import { render, staticRenderFns } from "./VaccinationRecordCard.vue?vue&type=template&id=24b41852&scoped=true&"
import script from "./VaccinationRecordCard.vue?vue&type=script&lang=js&"
export * from "./VaccinationRecordCard.vue?vue&type=script&lang=js&"
import style0 from "./VaccinationRecordCard.vue?vue&type=style&index=0&id=24b41852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b41852",
  null
  
)

export default component.exports